module.exports = __webpack_public_path__ + "img/swap.a2a98999.svg";